import { MetricModel } from 'models/Market/Metric';
import { Dot } from 'recharts';
import { ExtendedActiveDotProps } from '../types';

export interface DayDotProps extends ExtendedActiveDotProps {
	dailyData: MetricModel[];
}

export default function DayDot(dotProps: DayDotProps) {
	const { payload, dailyData } = dotProps;
	const actualData = dailyData.find(m => m?.key === payload?.key);
	if (actualData) {
		return <Dot {...dotProps} r={4} />;
	}
	return <Dot {...dotProps} r={0} opacity={0} style={{ pointerEvents: "none" }} />;
}
